exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.feedback-box[data-v-e7e54e2a] {\n  margin-top: 9.067%;\n  padding: 5.73% 15.152% 9.73%;\n  text-align: center;\n  border-radius: 1.5em;\n  background-color: #eddcab;\n}\n.feedback-box .feedback-leading[data-v-e7e54e2a] {\n  font-size: 0.76em;\n  font-weight: 600;\n  color: #96693b;\n  font-family: roundedMplus;\n}\n.feedback-box .feedback-button[data-v-e7e54e2a] {\n  display: block;\n  margin-top: 7.24%;\n  padding: 1.934% 0;\n  font-size: 1.3em;\n  color: #e4faf4;\n  background-color: #58bba7;\n  text-decoration: none;\n  box-shadow: 0 0.3em #45a38e;\n  border-radius: 0.5em;\n}\n", ""]);

// exports
